import { supabase } from './supabaseClient';
import type { ProjectFolder } from '../types';

/**
 * Pastas de projetos.
 *
 * O RLS ja decide o que cada um enxerga (pasta pessoal do proprio dono, e as
 * pastas das organizacoes de que participa), entao `list` nao filtra nada na
 * mao: pedir filtro aqui abriria a porta para a tela e o banco discordarem
 * sobre quem ve o que.
 *
 * A movimentacao de projeto NAO mora aqui. Ela e um UPDATE em `projects`
 * (`projectService.update`), e quem a expoe e o ProjectContext, que e dono da
 * lista de projetos e precisa refletir a mudanca na hora.
 */
export const folderService = {
  async list(): Promise<ProjectFolder[]> {
    const { data, error } = await supabase
      .from('project_folders')
      .select('*')
      .order('name', { ascending: true });

    if (error) throw error;
    return (data || []) as ProjectFolder[];
  },

  /**
   * `organizationId` nulo cria pasta pessoal. `ownerId` vai explicito porque a
   * policy de INSERT exige `owner_id = auth.uid()`: deixar o default para o
   * banco daria erro de RLS em vez de erro de programacao.
   */
  async create(name: string, ownerId: string, organizationId: string | null = null): Promise<ProjectFolder> {
    const { data, error } = await supabase
      .from('project_folders')
      .insert({ name: name.trim(), owner_id: ownerId, organization_id: organizationId })
      .select()
      .single();

    if (error) throw error;
    return data as ProjectFolder;
  },

  async rename(id: string, name: string): Promise<ProjectFolder> {
    const { data, error } = await supabase
      .from('project_folders')
      .update({ name: name.trim(), updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return data as ProjectFolder;
  },

  /**
   * Apagar a pasta devolve os projetos para "Sem pasta", nunca os leva junto:
   * quem garante isso e o `ON DELETE SET NULL` de `projects.folder_id`.
   */
  async remove(id: string): Promise<void> {
    const { error } = await supabase
      .from('project_folders')
      .delete()
      .eq('id', id);

    if (error) throw error;
  }
};
